/*global window */
(function() {

  'use strict';
  
      var attivaModal = function(message, buttons, idButtons, callBack) {
        $('.modal-body p').hide();
        $('.modal-body p').html(message);
        $('.modal-body p').show();

        if (!$('.modal').hasClass('in')) {
          $('.modal').modal('show');
        }

        $('.modal-footer').html('');

        if (typeof buttons !== 'undefined' && buttons !== null) {
          if (buttons.length > 0) {
            $.each(buttons, function(index, value) {
              if (idButtons[index] === '') {
                $('.modal-footer').append('<button type="button" class="btn btn-default" data-bs-dismiss="modal">' + value + '</button>');
              } else {
                $('.modal-footer').append('<button type="button" class="btn btn-default" id="modal-action-' + idButtons[index] + '">' + value + '</button>');
              }
            });
          }
        }
        if (typeof callBack === 'function') {
          callBack();
        }
      };


      var validator = $('#form-contatto').validate({
        focusInvalid: false,
        onkeyup: false,
        onfocusout: false,
        errorElement: 'p',
        errorPlacement: function(error) {
          var tmpl = '<i class="fas fa-exclamation" style="font-size: 70px; color:orange;"></i><br><br>' +
          '<h4>' + $(error).html() + '</h4><br>';

          attivaModal(tmpl, ['Chiudi'], ['']);

          $('div#errors').show();
          if ($('div#errors').html() === '') {
            error.appendTo('div#errors');
          }
        },
        rules: {
          checkPrivacy: {
            required: true
          },
          telefono: {
            required: true
          },
          email: {
            required: true,
            email: true
          },
          nominativo: {
            required: true
          },
        },
        messages: {
          checkPrivacy: {
            required: setup.texts.testi['check-privacy']
          },
          telefono: {
            required: setup.texts.testi['inserire-telefono']
          },
          email: {
            required: setup.texts.testi['inserire-mail'],
            email: setup.texts.testi['mail-corretta']
          },
          nominativo: {
            required: setup.texts.testi['inserire-nominativo']
          },
        },
        invalidHandler: function() {
          $('div#errors').html('');
        }
      });


    $('body').on('click', '.invia-contatto', function() {
      

      var arr = {};
      
      arr.nominativo = $('#nominativo').val();
      arr.email = $('#email').val();
      arr.telefono = $('#telefono').val();
      arr.messaggio = $('#messaggio').val();
      
      arr.check_privacy = $('#checkPrivacy').is(':checked');
      
      arr.id_pagina = $('#id_pagina').val();
      arr.pagina = $('#pagina').val();
      var jsonString = JSON.stringify(arr);


      //console.log(arr);
      if (validator.form()) {
        var tmpl = '<i class="far fa-clock" style="font-size: 70px; color:orange;"></i><br><br>' +
        '<h4>' + window.attendere + '</h4><br><br>';
        attivaModal(tmpl, null, null);
        //console.log($('#allegato')[0].files[0]);
        //console.log($('#allegato'));
        var fd = new FormData();
        fd.append('action', 'invia-contatto');
        fd.append('obj', jsonString);
        fd.append('language', window.language);
        //if($('#allegato').val()) fd.append('image', $('#allegato')[0].files[0]);
        //debugger;
        $.ajax({
          url: '/ajax/function.php',
          method: 'POST',
          contentType: false,
          processData: false,
          data: fd,
          success: function(ret) {
            var arr = ret.split('|');
            var tmpl = '';

            // console.log(arr[0]);
            if (arr[0] == 1) {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                'event': 'email-sent'
              });
              
              tmpl = '<i class="fas fa-check" style="font-size: 70px; color:green;"></i><br><br><h4>' + arr[1] + '</h4><br><br>';
              attivaModal(tmpl, ['Chiudi'], [''], null);
              setTimeout(function() {
                document.location = '?mail-inviata';
              }, 2000);

            } else {
              tmpl = '<i class="fas fa-times-circle" style="font-size: 70px; color:orange;"></i><br><br><h4>' + arr[1] + '</h4><br><br>';
              attivaModal(tmpl, ['Chiudi'], [''], null);
            }
          }
        });
        return false;
      }
      return false;
    });

      
}());
